import React, { forwardRef, memo } from 'react'

const LocationIcon = forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      ref={ref}
      width="58.8"
      height="58.8"
      viewBox="0 0 84 84"
      fill="none"
      {...props}>
      <circle cx="41.9496" cy="41.9496" r="41.9496" fill="#78BE20" />
      <path
        d="M54.5001 43.7935L42.0267 56.2669C41.7945 56.4992 41.5189 56.6834 41.2155 56.809C40.9122 56.9347 40.5871 56.9994 40.2587 56.9994C39.9304 56.9994 39.6052 56.9347 39.3019 56.809C38.9985 56.6834 38.7229 56.4992 38.4907 56.2669L25.2329 43.0091C25.0007 42.777 24.8165 42.5014 24.6908 42.198C24.5652 41.8947 24.5005 41.5695 24.5005 41.2412C24.5005 40.9128 24.5652 40.5877 24.6908 40.2843C24.8165 39.981 25.0007 39.7053 25.2329 39.4732L40.2064 24.4998L58.2501 42.5435L54.5001 43.7935Z"
        stroke="white"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M41.375 43.2498C43.1009 43.2498 44.5 41.8506 44.5 40.1248C44.5 38.3989 43.1009 36.9998 41.375 36.9998C39.6491 36.9998 38.25 38.3989 38.25 40.1248C38.25 41.8506 39.6491 43.2498 41.375 43.2498Z"
        stroke="white"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.1655 37.9154L28.2483 26.9998"
        stroke="white"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.7498 54.4998C60.7498 55.1628 60.4864 55.7987 60.0175 56.2675C59.5487 56.7364 58.9128 56.9998 58.2498 56.9998C57.5867 56.9998 56.9508 56.7364 56.482 56.2675C56.0131 55.7987 55.7498 55.1628 55.7498 54.4998C55.7498 51.9998 58.2498 48.2498 58.2498 48.2498C58.2498 48.2498 60.7498 51.9998 60.7498 54.4998Z"
        stroke="white"
        strokeWidth="3.22689"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
)

LocationIcon.displayName = 'LocationIcon'

export default memo(LocationIcon)
